<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    headeTitle: {
      type: String,
      default: '',
    },
    routePath: {
      type: String,
      default: '',
    },
    timeZones: {
      type: String,
      default: '',
    },
    showRefineSearch: {
      type: Boolean,
      default: false,
    },
    showTimeZones: {
      type: String,
      default: 'Y',
    },
    showNewSearch: {
      type: Boolean,
      default: false,
    },
    showCreatePlusIcon: {
      type: Boolean,
      default: false,
    },
    showNewLabel: {
      type: String,
      default: 'New Search',
    },
    showSearch: {
      type: Boolean,
      defaulf: true,
    },
    showAdvanced: {
      type: Boolean,
      default: false,
    },
    showDownload: {
      type: Boolean,
      defaulf: true,
    },
    disableDownload: {
      type: Boolean,
      defaulf: false,
    },
    fields: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
      isDefault: true,
    }
  },
  mounted() {
    document.body.addEventListener('keyup', (e) => {
      if (e.keyCode === 27) {
        this.isDefault = true
        this.isOpen = false
      }
    })
    this.retainSearchCriteria()
  },
  methods: {
    retainSearchCriteria() {
      let savedSearchData = this.$store.state.saveSearchModule.searchData || null
      let summaryStatus = this.$store.state.saveSearchModule.summaryStatus
      if (savedSearchData !== null && summaryStatus) {
        // this.showBaseSearch = true
        // this.collapseBlockClass = 'collapse show'
        document.getElementById('collapse-2').style.display = 'block'
        this.isOpen = true
      }
      else {
        // this.showBaseSearch = false
        // this.collapseBlockClass = ''
        document.getElementById('collapse-2').style.display = 'none'
        this.isOpen = false
      }
    },
    showSearchMenuReports() {
      if(this.isOpen) {
        document.getElementById('collapse-2').style.display = 'none'
      } else document.getElementById('collapse-2').style.display = 'block'

      this.isOpen = !this.isOpen
      // this.isDefault = false
    },
    closeButton() {
      // this.isDefault = true
      this.isOpen = false
    },
    onSearchSubmit(e) {
      this.$emit('searchSubmit', e)
    },
    onAdvanceSearchChanged(e) {
      this.$emit('advanceSearchChanged', e)
    },
    downloadTo() {
      this.$emit('downloadTo')
    },
    navigateToRefineSearch() {
      this.$emit('refineSearch')
    },
    navigateToNewSearch() {
      this.$emit('newSearch')
    },
    navigateTo() {
      this.$router.push({ path: this.routePath })
    },
  },
}
</script>

<template>
  <b-container class="mb-3 extendedWidth">
    <b-row
      v-if="isDefault"
      align-h="between"
      :class="$style.menuHeader"
      class="py-2"
    >
      <b-col class="col-12 col-md-8 pl-0">
        <BaseELabel class="pageTitle" :label="headeTitle" />
      </b-col>

      <b-col class="col-12 col-md-4 pr-0">
        <div class="text-right right-icons">
          <BaseEButton
            v-if="showSearch"
            v-b-toggle.collapse-2
            pre-icon="search"
            variant="cancel"
            @click="showSearchMenuReports"
          >
            Search
          </BaseEButton>
          <BaseEButton
            v-if="showDownload"
            v-b-tooltip.hover
            pre-icon="download"
            variant="cancel"
            :disabled="disableDownload"
            @click="downloadTo"
          >
            Download
          </BaseEButton>

          <b-link
            v-if="showCreatePlusIcon"
            v-b-tooltip.hover
            :class="$style.headerPlus"
            class="rounded-circle ml-2"
            :title="title"
            @click="navigateTo"
          >
            <BaseIcon :class="$style.headerPlus" name="plus" />
          </b-link>

          <BaseEButton
            v-if="showRefineSearch"
            name="refineSearch"
            variant="cancel"
            @click="navigateToRefineSearch"
          >
            Refine Search
          </BaseEButton>

          <BaseEButton
            v-if="showNewSearch"
            variant="cancel"
            name="newSearch"
            @click="navigateToNewSearch"
          >
            {{ showNewLabel }}
          </BaseEButton>
        </div>
      </b-col>
    </b-row>

    <div id="collapse-2">
      <BaseSearchReport
        v-if="isOpen"
        :fields="fields"
        :show-time-zones="showTimeZones"
        :selectstandardtime="timeZones"
        :show-advanced="showAdvanced"
        :title="headeTitle"
        @searchSubmit="onSearchSubmit"
        @closeButton="closeButton"
        @advanceSearchChanged="onAdvanceSearchChanged"
      />
    </div>

    <!-- <BaseForm v-if="formDisp"/> -->
  </b-container>
</template>

<style lang="scss" scoped>
/* stylelint-disable selector-pseudo-element-no-unknown */

@import '@design';
::v-deep .pageTitle {
  font-size: 2.25rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2rem;
  color: $color-text-primary;
}
</style>

<style lang="scss" module>
@import '@design';
.iconBackground,
.iconBackground:hover {
  padding: 2px 7px 5px;
  background-color: rgba(0, 0, 0, 0.05);
}
.menuHeader {
  padding: 5px;
  background-color: #fff;
}

a.headerPlus {
  padding: 2px 7px 4px;
  line-height: 20px;
  color: #f1f1f1;
  vertical-align: middle;
  background-color: rgb(231, 229, 229);
}
.refineSearch {
  // height: 22px;
  // padding: 0 2rem;
  font-size: 0.8rem;
  line-height: 0.5rem;
  color: $color-text-gray;
  // text-shadow: 0 0 0 #d3631a !important;
  background-color: #fff !important;
  // border: 1px solid #f37421 !important;
  // box-shadow: inset 0 0 0 #a14408 !important;
}
.newSearch {
  // height: 22px;
  // padding: 0.01rem 2rem;
  font-size: 0.8rem;
  line-height: 0.5rem;
  color: $color-text-gray;
  text-shadow: 0;
  background-color: #fff !important;
  box-shadow: 0;
}
</style>
